import axios from 'axios';
import React from 'react';
import './App.css'; 
import { debounce } from "lodash";
import CompaniesFilter from './components/CompaniesFilter.component';
import Company from './components/company.component';
import InfiniteScroll from 'react-infinite-scroll-component';
import myIcon from './assets/errorIcon.svg';
class App extends React.Component {
  state = {
    companies: [],
    locations: [],
    typeOfFinancing: [],
    selectedLocation: 0,
    selectedTypeOfFinancing: 0,
    searchText: '',
    hasMore: true,
    empty: false,
    page: 1, 
    query: '',
    perPage: 12
  }
  async componentDidMount() {
    const locationsURL = 'https://fundingobservatory.org/wp-json/wp/v2/location';
    const typeOfFinancingURL = 'https://fundingobservatory.org/wp-json/wp/v2/type_of_financing';
    let locationsData = await axios.get(locationsURL), typeOfFinancingData = await axios.get(typeOfFinancingURL);
    this.setState({
      locations: locationsData.data,
      typeOfFinancing: typeOfFinancingData.data
    });
    this.fetchCompanies();
  }

  componentDidUpdate() {
    // console.log(this.state);
  }

  fetchCompanies = async () => {
    const { page, perPage, query } = this.state;
    let saveCompanies = [];
    let hasMore = true;
    let empty = false;
    const url = `https://fundingobservatory.org/wp-json/wp/v2/company?${query}status=publish&per_page=${perPage}&page=${page}&_embed=wp:featuredmedia`;
    try {
      const data = await axios.get(url);
      if(parseInt(page) > 1) {
        saveCompanies = [...this.state.companies];
        data.data.forEach(element => {
          saveCompanies.push(element);
        });
      } else {
        saveCompanies = data.data;
      }
      if(!data.data.length) {
        hasMore = false;
        empty = true;
      }
      if(data.data.length < perPage) {
        hasMore = false;
      }
      this.setState({
        companies: saveCompanies,
        hasMore,
        empty
      })
    } catch(error) {
      this.setState({
        hasMore: false
      })
    }
  }

  delayUpdate = debounce(() => {
    this.onSubmit()
  }, 250);

  updateDropdown = (event) => {
    const { name, value } = event.target;
    this.setState({
      [name]: value
    }, ()=> this.delayUpdate())
  }

  onSubmit = (event) => {
    if(event) {
      event.preventDefault();
    }
    let query = '';
    const {selectedLocation, selectedTypeOfFinancing, searchText } = this.state;
    if(selectedLocation > 0) {
      query += `location=${selectedLocation}&`;
    }
    if(selectedTypeOfFinancing > 0) {
      query += `type_of_financing=${selectedTypeOfFinancing}&`;
    }
    if(searchText) {
      query += `search=${searchText}&`;
    }
    this.setState({companies: [], query: query, page: 1, hasMore: true, empty: false}, () => {this.fetchCompanies()});
  }
  fetchMoreData = () => {
    setTimeout(() => {
      let { page } = this.state;
      this.setState({
        page: page + 1
      }, () => {this.fetchCompanies()});
    }, 250)
  }

  render() {
    const { companies, locations, typeOfFinancing, selectedLocation, searchText, selectedTypeOfFinancing, hasMore, empty } = this.state;
    return (
      <React.Suspense fallback={<div className="loader"></div>}>
        <CompaniesFilter locations={locations} searchText={searchText} typeOfFinancing={typeOfFinancing} selectedLocation={selectedLocation} selectedTypeOfFinancing={selectedTypeOfFinancing} updateDropdown={this.updateDropdown} onSubmit={this.onSubmit}/>
        <InfiniteScroll
            scrollableTarget="body"
            dataLength={companies.length}
            next={this.fetchMoreData}
            pullDownToRefreshThreshold={1}
            hasMore={true}
            loader={hasMore ? <div className="loader-container"><div className="loader"></div></div> : ''}
            style={{overflow: 'visible'}}
          >
          <Company companies={companies} />
        </InfiniteScroll>
        { empty && 
          <div className="notfound">
              <div className="notfound-icon">
                <img src={myIcon} alt="No result found" />
              </div>
              <h4>No result found</h4>
              <p>We can't find any company matching your search.</p>
          </div>
        }
      </React.Suspense>
    );
  }
}

export default App;
